import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import { formatMoney, formatNumber } from "../../../helpers/formatters";

const mayorACeroValidator = {
  validator: value => Number(value) < 0 || (!value && value !== 0),
  message: () => "No permitido"
};

export type Inputs =
  | "numeroAsesores"
  | "consolidadoPresupuesto"
  | "numeroProspectosPresupuesto"
  | "totalVentasPresupuesto";

export type Buttons = never;

export const formConfigBuilder: (
  disabled: boolean
) => FormBuilderConfig<Inputs, Buttons> = disabled => ({
  inputs: [
    {
      name: "numeroAsesores",
      label: "Número de Asesores",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled
      }
    },
    {
      name: "consolidadoPresupuesto",
      label: "Meta Consolidada",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled
      }
    },
    {
      name: "numeroProspectosPresupuesto",
      label: "Número de Prospectos",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled
      }
    },
    {
      name: "totalVentasPresupuesto",
      label: "Ingreso",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatMoney(Number(value)),
        disabled
      }
    }
  ],
  buttons: [],
  validations: {
    numeroAsesores: {
      mayorACeroValidator
    },
    consolidadoPresupuesto: {
      mayorACeroValidator
    },
    numeroProspectosPresupuesto: {
      mayorACeroValidator
    },
    totalVentasPresupuesto: {
      mayorACeroValidator
    }
  },
  rows: [
    [
      "numeroAsesores",
      "consolidadoPresupuesto",
      "numeroProspectosPresupuesto",
      "totalVentasPresupuesto"
    ]
  ]
});
